<template>

    <div class="signup-page">
        <Header></Header>
        <section class="signup-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Forgot Password</h2>
                        <form class="form" v-on:submit.prevent="signupFormSubmit">
                            <div class="input-field form-input">
                                <label for="your-email">Your Email</label>
                                <input type="text" placeholder="johndoe@email.com" id="your-email" v-model="email"
                                       v-on:blur="yourEmail(email)">
                                <p class="error-input" v-if="emailFlag">Email address is required</p>
                            </div>
                            <div class="input-submit">
                                <button type="submit" v-if="!FormSubmited">SUBMIT</button>
                                <span v-if="FormSubmited">SUBMIT...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from './Header'
    import Footer from './Footer'
    import axios from 'axios'
    import router from '../router'
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)

    export default {
        name: 'ForgotPassword',
        components: {
            'Header': Header,
            'Footer': Footer
        },
        mounted () {
            console.log(Date.now() + Math.random())
            console.log(this.generatePassword())
        },
        data() {
            var userdata = localStorage.getItem('cbs_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            }
            return {
                nameFlag: false,
                emailFlag: false,
                FormSubmited: false,
                email: '',
                name: '',
                userData: userdata,
                status: '',
                oldPassword: '',
                password: '',
                confirmPassword: '',
                profileId: '',
                artistId: router.history.current.params.id,
                msg: 'Welcome to Your Vue.js App'
            }
        },
        methods: {
            generatePassword: function() {
                var length = 8,
                    charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
                    retVal = "";
                for (var i = 0, n = charset.length; i < length; ++i) {
                    retVal += charset.charAt(Math.floor(Math.random() * n));
                }
                return retVal;
            },
            yourName: function (msg) {
                if (!msg) {
                    this.nameFlag = true
                } else {
                    this.nameFlag = false
                }
            },
            yourEmail: function (msg) {
                if (!msg) {
                    this.emailFlag = true
                } else {
                    this.emailFlag = false
                }
            },
            signupFormSubmit: function (event) {
                this.FormSubmited = true
                try {
                    axios.post('/forgotPassword', {
                        email: this.email
                    }).then(res => {
                        this.FormSubmited = false
                        if(res.data){
                            Vue.$toast.open(
                                {
                                    message: 'Please check your mail!',
                                    type: 'success',
                                    position: 'top-right'
                                    // all other options
                                }
                            )
                        } else {
                            Vue.$toast.open(
                                {
                                    message: 'Something went wrong!',
                                    type: 'error',
                                    position: 'top-right'
                                    // all other options
                                }
                            )
                        }

                    }).catch(err => {
                        this.FormSubmited = false
                        console.log(err)
                    })
                } catch (e) {
                    this.FormSubmited = false
                    console.log(e)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue